import MerchantHealthTable from './MerchantHealthTable'

export default MerchantHealthTable
